export var input = '$_1ZT7c';
export var errorPlaceholder = '$_1tP9A';